
  import { defineComponent } from 'vue';
  import EmptyStateEntry from '@/ui/pages/EmptyStateEntry';

  export default defineComponent({
    name: 'ApprovalEmpty',
    components: {
      EmptyStateEntry,
    },
  });
